export default "__VITE_ASSET__DmpOg9nu__"